import React, { Component } from "react";
import { connect } from "react-redux";
import ProfileSettings from "./profile_settings_wrapper";
import { Tabs, Tab, TabList, TabPanel } from "../../lib/tab";
import PaymentMethod from "./payment_methods";
import { Col, Grid, Row } from "react-bootstrap";
import { getMyCards } from "../../../action_managers/subscriptions";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { If } from "react-extras";

class AccountPage extends Component {
  componentDidMount() {
    this.props.getMyCards();
  }
  state = {
    tabIndex: 0,
  };
  render() {
    return (
      <div className={"account-page-wrapper"}>
        <Grid fluid>
          <Row>
            <Col xs={12} md={8} mdOffset={2}>
              <Tabs
                selectedIndex={this.state.tabIndex}
                onSelect={tabIndex => this.setState({ tabIndex })}>
                <TabList>
                  <If condition={isEmpty(get(this.props.payments, "cards"))}>
                    <div style={{ height: "40px" }} />
                  </If>
                  <If condition={!isEmpty(get(this.props.payments, "cards"))}>
                    <Tab>Profile</Tab>
                    <Tab>Payment Methods</Tab>
                  </If>
                </TabList>
                <TabPanel>
                  <ProfileSettings />
                </TabPanel>
                <TabPanel>
                  <PaymentMethod />
                </TabPanel>
              </Tabs>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default connect(
  state => ({
    payments: state.payments,
  }),
  {
    getMyCards,
  }
)(AccountPage);
